var _circle, _circle2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCapsule2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    display: "none",
    "data-characteristic": "capsule2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.75,
    r: 5.125,
    fill: "white",
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.75,
    r: 7.375,
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4930_17345)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.75,
    width: 10,
    height: 10,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.75,
    r: 5,
    "data-characteristic": "color2Extra"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4930_17345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.329565 12.4119C0.290172 14.7248 1.987 16.6475 4.38764 17.7572C6.78827 18.8668 9.69607 19.0724 12.4713 18.3288C15.2466 17.5851 17.662 15.9532 19.1862 13.7919C20.7104 11.6306 21.2186 9.11704 20.5988 6.80416L10.1346 9.60803L-0.329565 12.4119Z",
    "data-characteristic": "color2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.02203 9.57084C10.0863 8.10433 10.1046 6.30253 9.06282 5.54646C8.02102 4.79039 6.31366 5.36633 5.24935 6.83285C4.18504 8.29936 4.16677 10.1012 5.20856 10.8572C6.25036 11.6133 7.95772 11.0374 9.02203 9.57084Z",
    fill: "url(#paint0_linear_4930_17345)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4930_17345",
    x: -4.3291,
    y: 2.8042,
    width: 29.1855,
    height: 19.9644,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_4930_17345"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4930_17345",
    x1: 5.73562,
    y1: 6.99001,
    x2: 9.51556,
    y2: 9.73327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4930_17345"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.75,
    width: 10,
    height: 10,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapsule2);
export default __webpack_public_path__ + "static/media/capsule2.da0cbc45e8a55a128bc81946747535a4.svg";
export { ForwardRef as ReactComponent };